import { render, staticRenderFns } from "./DialogTeachingCoolSelect.vue?vue&type=template&id=82c21a4c&"
import script from "./DialogTeachingCoolSelect.vue?vue&type=script&lang=js&"
export * from "./DialogTeachingCoolSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports